'use strict';
const mmWidgets = require('./mm-widgets');

require('./section-handler-widget');
require('./show-progress-message');


mmWidgets.fn.microsoftTeamsCrowdlinkAuthenticationWidget = function ({fileId, microsoftTeamsModel, microsoftOAuthApi, crowdlinkAuthenticator} = {}) {
	if (!fileId || !microsoftTeamsModel || !microsoftOAuthApi || !crowdlinkAuthenticator) {
		console.error({fileId, microsoftTeamsModel, microsoftOAuthApi, crowdlinkAuthenticator});
		throw new Error('invalid-args');
	}
	const recognisedErrors = ['msteams-capacity-exceeded', 'login-required', 'not-authenticated'];
	return mmWidgets.each(this, async function () {
		const widget = this.sectionHandlerWidget(),
			loginButton = widget.find('[data-mm-role~="login-button"]'),
			handleError = (error, defaultSection) => {
				if (!defaultSection) {
					throw new Error('invalid-args');
				}
				widget.removeClass('hidden');
				if (recognisedErrors.includes(error)) {
					widget.showSection(error);
				} else {
					widget.showSection(defaultSection);
				}
			};
		loginButton.click(async () => {
			widget.showProgressMessage('Signing in, please wait...');
			try {
				const authResponse = await microsoftTeamsModel.authenticate(),
					authProfile = await microsoftOAuthApi.authResponseToProviderProfile(authResponse),
					externalContextId = await microsoftTeamsModel.getExternalContextId(authProfile.token);
				await crowdlinkAuthenticator.authenticate({
					fileId,
					displayName: authProfile.email,
					externalContextId
				});
				widget.addClass('hidden');
			} catch (error) {
				handleError(error, 'not-authenticated');
			}
			widget.trigger('login-clicked');
		});
		try {
			const authProfile = await microsoftOAuthApi.headlessAuth(),
				externalContextId = await microsoftTeamsModel.getExternalContextId(authProfile.token);
			await crowdlinkAuthenticator.authenticate({
				fileId,
				displayName: authProfile.email,
				externalContextId
			});
			widget.addClass('hidden');
			microsoftTeamsModel.initialisationComplete();
		} catch (error) {
			handleError(error, 'login-required');
			microsoftTeamsModel.initialisationComplete();
		}
	});
};
